// extracted by mini-css-extract-plugin
export var containerFluid = "thematic-pillar-card-module--container-fluid--TCuDo";
export var content = "thematic-pillar-card-module--content--KzzrD";
export var ctnBtn = "thematic-pillar-card-module--ctnBtn--d5rVT";
export var icon = "thematic-pillar-card-module--icon---7e2t";
export var textCtn = "thematic-pillar-card-module--textCtn--Z2NFO";
export var thematicCard = "thematic-pillar-card-module--thematicCard--RWy2y";
export var title = "thematic-pillar-card-module--title--Y8+59";
export var triangle = "thematic-pillar-card-module--triangle--1bUgX";